import { DocumentClassAttributes, DocumentDetailTypeAttributes, DocumentTypeAttributes, ExpenseReasonAttributes } from '@albatrosdeveloper/ave-models-package';
import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  SimpleChanges
} from '@angular/core';
import {
  FormGroup,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { OrdersListService } from '../../sales/order-list-components/order-list.service';
import { IRequestResult } from 'app/common/interfaces';
import { DocumentTypeService } from '../../document/document-type/document-type.service';
import { SourceToSetSerialEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/source-to-set-serial.enum";
import { EmissionPointService } from '../../document/emission-point/emission-point.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Output, EventEmitter } from '@angular/core';
import { ExpenseReasonService } from '../../payment-master/expense-reason/expense-reason.service';
import { DocumentLineTypeService } from '../../document/document-type-line/document-type-line.service';
@Component({
  selector: 'app-documents-filters',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    NgxMatSelectSearchModule
  ],
  templateUrl: './documents-filters.component.html',
})
export class DocumentsFiltersComponent {

  constructor(
    private readonly ordersListService: OrdersListService,
    private readonly documentClassService: DocumentTypeService,
    private readonly documentLineTypeService : DocumentLineTypeService,
    private readonly emisionPointService: EmissionPointService,
    private snackBar: MatSnackBar,
    private readonly expenseReasonService: ExpenseReasonService
  ) {

  }

  @Input() form!: FormGroup;

  @Input() documentType: boolean = false;
  @Input() documentTypeFilter: boolean = false;
  @Input() documentTypeListFilter: string[] = [];
  @Input() documentTypeLine: boolean = false;
  @Input() documentClass: boolean = false;
  @Input() documentClassWhitMongoId: boolean = false;
  @Input() typeEmissionPoint: boolean = false;
  @Input() pointEmission: boolean = false;
  @Input() expenseReason: boolean = false;
  @Input() typeDocumentClass: string = '';
  @Input() loadData: boolean = undefined;
  @Input() requestType: boolean = false;
  @Output() filterApply = new EventEmitter<void>();

  searchDocumentType: string = '';
  searchDocumentTypeLine: string = '';
  searchDocumentClass: string = '';

  documentTypeList: DocumentTypeAttributes[] = [];
  filteredDocumentTypeList: DocumentTypeAttributes[] = [];

  documentTypeLineList: DocumentDetailTypeAttributes[] = [];
  filteredDocumentTypeLineList: DocumentDetailTypeAttributes[] = [];

  documentClassList: DocumentClassAttributes[] = []
  filteredDocumentClassList: any[] = [];

  emissionPointList: any[] = [];
  listFilteremissionPointList: any[] = [];

  expenseReasonList: ExpenseReasonAttributes[] = [];
  expenseReasonFilteredtList: ExpenseReasonAttributes[] = [];

  typeEmissionPointList: number[] = Object.values(SourceToSetSerialEnum).filter((value): value is number => typeof value === 'number');

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['loadData'] && changes['loadData'].currentValue === true) {
      this.loadAllData();
    }
  }

  ngOnInit(): void {
    if (this.loadData === undefined) {
      this.loadAllData();
    }
  }

  private loadAllData(): void {
    if (this.documentClass || this.documentClassWhitMongoId) this.fetchDocumentClass();
    if (this.documentType) this.fetchTypeDocuments();
    if (this.documentTypeFilter && Array.isArray(this.documentTypeListFilter)) this.fetchTypeDocumentsFilter();
    if (this.documentTypeLine) this.fetchTypeLineDocuments();
    if (this.pointEmission) this.fetchAllEmissionPoint();
    if (this.expenseReason) this.fetchAllExpenseReasons()
  }
  onRequestTypeChange(): void {
    this.filterApply.emit();
  }

  private fetchAllExpenseReasons(): void {
    this.expenseReasonService
      .findAllWithCount({
        currentPage: 1,
        limitPerPage: 50,
        sort: "createdAt",
        sortDirection: "DESC",
      })
      .subscribe((data) => {
        this.expenseReasonList = data?.data?.data ?? [];
        this.expenseReasonFilteredtList = data?.data?.data ?? [];
      });
  }

  private fetchAllEmissionPoint(): void {
    this.emisionPointService.findToComboBox().subscribe({
      next: (res) => {
        this.emissionPointList = res.data;
        this.listFilteremissionPointList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtner tipos de emisión.", "Cerrar", { duration: 5000 });
      },
    });
  }

  private fetchTypeDocuments(): void {
    this.documentClassService.findToComboBox().subscribe({
      next: (res: IRequestResult<DocumentTypeAttributes[]>) => {
        this.documentTypeList = res?.data ?? [];
        this.filteredDocumentTypeList = res?.data ?? [];
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener los tipos de documentos.", "Cerrar", { duration: 5000 });
      },
    });
  }

  //Documentos ya seleccionados
  private fetchTypeDocumentsFilter(): void {
    this.documentClassService.findToRelated(this.documentTypeListFilter).subscribe({
      next: (res: IRequestResult<DocumentTypeAttributes[]>) => {
        this.documentTypeList = res?.data ?? [];
        this.filteredDocumentTypeList = res?.data ?? [];
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener los tipos de documentos.", "Cerrar", { duration: 5000 });
      },
    });
  }

   private fetchTypeLineDocuments(): void {
    this.documentLineTypeService.findToComboBox().subscribe({
      next: (res: IRequestResult<DocumentDetailTypeAttributes[]>) => {
        this.documentTypeLineList = res?.data ?? [];
        this.filteredDocumentTypeLineList = res?.data ?? [];
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener los tipos de documentos.", "Cerrar", { duration: 5000 });
      },
    });
  }

  private fetchDocumentClass(): void {
    let dataToFilter = {
      type: this.typeDocumentClass ?? null
    }
    this.ordersListService.fetchDocumentClasses(dataToFilter).subscribe((res) => {
      this.documentClassList = res.data;
      this.filteredDocumentClassList = res.data;
    })
  }

  getListTypeLabel(type: number): string {
    const labels = {
      [SourceToSetSerialEnum.COMPANY]: 'COMPAÑIA',
      [SourceToSetSerialEnum.SALES_OFFICE]: 'OFICINA DE VENTA',
      [SourceToSetSerialEnum.SUB_ROUTE]: 'RUTA',
    };
    return labels[type] || type;
  }

  getDisplayValue(list: any[], ids: any): string {
    if (Array.isArray(ids)) {
      return list
        .filter(item => ids.includes(item._id) || ids.includes(item.id) || ids.includes(item.name) || ids.includes(item.code))
        .map(item => item.name)
        .join(', ');
    } else {
      return list.find(item => item._id === ids || item.id === ids || item.name === ids || item.code === ids)?.name ?? '';
    }
  }

  filterDocumentType(query: string): void {
    const value = query?.toLowerCase() ?? '';

    if (value === '') {
      this.filteredDocumentTypeList = this.documentTypeList;
    } else {
      this.filteredDocumentTypeList = this.documentTypeList.filter(item =>
        item.name?.toLowerCase().includes(value) || item.code?.toLowerCase().includes(value)
      );
    }
  }

  filterDocumentTypeLine(query: string): void {
    const value = query?.toLowerCase() ?? '';

    if (value === '') {
      this.filteredDocumentTypeLineList = this.documentTypeLineList;
    } else {
      this.filteredDocumentTypeLineList = this.documentTypeLineList.filter(item =>
        item.name?.toLowerCase().includes(value) || item.code?.toLowerCase().includes(value)
      );
    }
  }

  getDisplayValueRequestType(values: boolean[]): string {
    if (!values || values.length === 0) {
      return '';
    }

    const labels = values.map(val => {
      if (val === true) return 'Extensión';
      if (val === false) return 'Creación';
      return '';
    }).filter(label => label !== '');

    return labels.join(', ');
  }

  filterExpenseReason(query: string): void {
    const value = query?.toLowerCase() ?? '';

    if (value === '') {
      this.expenseReasonFilteredtList = this.expenseReasonList;
    } else {
      this.expenseReasonFilteredtList = this.expenseReasonList.filter(item =>
        item.name?.toLowerCase().includes(value)
      );
    }
  }

  filterPointEmission(query: string): void {
    const value = query?.toLowerCase() ?? '';

    if (value === '') {
      this.listFilteremissionPointList = this.emissionPointList;
    } else {
      this.listFilteremissionPointList = this.emissionPointList.filter(item =>
        item.name?.toLowerCase().includes(value)
      );
    }
  }

  filterDocumentClass(query: string): void {
    const value = query?.toLowerCase() ?? '';

    if (value === '') {
      this.filteredDocumentClassList = this.documentClassList;
    } else {
      this.filteredDocumentClassList = this.documentClassList.filter(item =>
        item.name?.toLowerCase().includes(value)
      );
    }
  }
}
